var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blur"},[_c('div',{class:{wrapper: _vm.blur}},[_vm._t("default")],2),(_vm.blur)?_c('div',{staticClass:"inner-wrapper"},[_vm._t("status")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }